module.exports = __webpack_public_path__ + "img/avatar3.ac5bca4f.png";